module.exports = __webpack_public_path__ + "static/media/origami5.688525eb.jpg";